import Vue from 'vue'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
Vue.use(VuePdfEmbed)
Vue.component('vue-pdf-embed', VuePdfEmbed)